import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { wineNaming } from "@/js/wine/wine.js";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { filterIntegerKey, filterDecimalKey } from "@/js/events/keycodes.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "AccountancyEcReconciliationDialog",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    ecOrder: Object
  },
  data: function data() {
    return {
      dialog: false,
      tab: null,
      firstLoaded: false,
      isLoadingAssociations: false,
      associations: [],
      addingExternalForms: [],
      updatingForms: [],
      updatingExternalForms: [],
      quantityToggleKey: false,
      isAddingExternal: [],
      isUpdating: [],
      isUpdatingExternal: [],
      isDeleting: [],
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    associationsByEcItemId: function associationsByEcItemId() {
      var _this$associations,
        _this2 = this;
      if (((_this$associations = this.associations) === null || _this$associations === void 0 ? void 0 : _this$associations.length) < 1) return [];
      var ecItemIds = _toConsumableArray(new Set(this.associations.map(function (x) {
        return x.ecItemData.id;
      })));
      var result = ecItemIds.map(function (id) {
        return {
          ecItemId: id,
          associations: _this2.associations.filter(function (x) {
            return x.ecItemData.id === id;
          })
        };
      });
      return result;
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this3.getOrderReconciliations();
          case 2:
            _this3.firstLoaded = true;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getOrderReconciliations: function getOrderReconciliations() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isLoadingAssociations = true;
              _this = _this4;
              _context2.next = 4;
              return request("/v1/accountancy/oc-ec-item-associations/ec-order/".concat(_this4.ecOrder.id_order, "/reconciliations-with-order-dispatchs"), "get", null, true, "api").catch(function (e) {
                _this.isLoadingAssociations = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load existing associations", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this4.associations = _toConsumableArray(response.data.value);
              _this4.isLoadingAssociations = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openExternalFormForItem: function openExternalFormForItem(itemId) {
      this.addingExternalForms = [].concat(_toConsumableArray(this.addingExternalForms), [{
        ecItemId: itemId,
        externalOcReference: "",
        nbBottlesAssociated: null,
        externalOcPaymentReference: "",
        ocItemTotalAmountCurrencyIncShipping: null,
        isValid: false
      }]);
    },
    saveAddingExternalForm: function saveAddingExternalForm(ecItemId) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              form = _this5.addingExternalForms.find(function (x) {
                return x.ecItemId === ecItemId;
              });
              _this5.isAddingExternal.push(ecItemId);
              data = {
                ecItemId: form.ecItemId,
                externalOcReference: form.externalOcReference,
                nbBottlesAssociated: +form.nbBottlesAssociated,
                ocItemUnitPriceCurrencyIncludeShipping: +form.ocItemUnitPriceCurrencyIncShipping,
                externalOcPaymentReference: form.externalOcPaymentReference
              };
              _this = _this5;
              _context3.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations/external-ec-to-oc", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create association", true);
                handleErrorData(_this, errorData);
                var index = _this.isAddingExternal.indexOf(ecItemId);
                _this.isAddingExternal.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this.isAddingExternal.indexOf(ecItemId);
              _this5.isAddingExternal.splice(index, 1);
              _this5.closeAddingExternalForm(ecItemId);
              _this5.getOrderReconciliations();
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    closeAddingExternalForm: function closeAddingExternalForm(ecItemId) {
      this.addingExternalForms = this.addingExternalForms.filter(function (x) {
        return x.ecItemId !== ecItemId;
      });
    },
    openUpdatingExternalForm: function openUpdatingExternalForm(associationId, ecItemId) {
      this.updatingExternalForms = [].concat(_toConsumableArray(this.updatingExternalForms), [{
        associationId: associationId,
        ecItemId: ecItemId,
        externalOcReference: this.associations.find(function (x) {
          return x.id === associationId;
        }).externalOcItemData.orderReference,
        nbBottlesAssociated: this.associations.find(function (x) {
          return x.id === associationId;
        }).nbBottlesAssociated,
        ocItemUnitPriceCurrencyIncShipping: this.associations.find(function (x) {
          return x.id === associationId;
        }).externalOcItemData.unitPriceCurrencyIncludeShipping,
        externalOcPaymentReference: this.associations.find(function (x) {
          return x.id === associationId;
        }).externalOcItemData.paymentReference,
        isValid: false
      }]);
    },
    saveUpdatingExternalForm: function saveUpdatingExternalForm(associationId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              form = _this6.updatingExternalForms.find(function (x) {
                return x.associationId === associationId;
              });
              _this6.isUpdatingExternal.push(associationId);
              data = {
                externalOcReference: form.externalOcReference,
                nbBottlesAssociated: +form.nbBottlesAssociated,
                ocItemUnitPriceCurrencyIncludeShipping: +form.ocItemUnitPriceCurrencyIncShipping,
                externalOcPaymentReference: form.externalOcPaymentReference
              };
              _this = _this6;
              _context4.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations/external-ec-to-oc/".concat(associationId), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                var index = _this.isUpdatingExternal.indexOf(associationId);
                _this.isUpdatingExternal.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this6.isUpdatingExternal.indexOf(associationId);
              _this6.isUpdatingExternal.splice(index, 1);
              _this6.closeUpdatingExternalForm(associationId);
              _this6.getOrderReconciliations();
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    closeUpdatingExternalForm: function closeUpdatingExternalForm(associationId) {
      this.updatingExternalForms = this.updatingExternalForms.filter(function (x) {
        return x.associationId !== associationId;
      });
    },
    openUpdatingForm: function openUpdatingForm(associationId, ocItemId) {
      var _this$associations$fi;
      this.updatingForms = [].concat(_toConsumableArray(this.updatingForms), [{
        associationId: associationId,
        ocItemId: ocItemId,
        quantity: this.associations.find(function (x) {
          return x.id === associationId;
        }).nbBottlesAssociated,
        paymentId: (_this$associations$fi = this.associations.find(function (x) {
          return x.id === associationId;
        }).payment) === null || _this$associations$fi === void 0 ? void 0 : _this$associations$fi.id,
        isValid: false
      }]);
    },
    saveUpdatingForm: function saveUpdatingForm(associationId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var form, data, _this, index;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              form = _this7.updatingForms.find(function (x) {
                return x.associationId === associationId;
              });
              _this7.isUpdating.push(associationId);
              data = {
                nbBottlesAssociated: +form.quantity,
                paymentId: form.paymentId
              };
              _this = _this7;
              _context5.next = 6;
              return request("/v1/accountancy/oc-ec-item-associations/".concat(associationId, "/quantity"), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                var index = _this.isUpdating.indexOf(associationId);
                _this.isUpdating.splice(index, 1);
                throw e;
              });
            case 6:
              index = _this7.isUpdating.indexOf(associationId);
              _this7.isUpdating.splice(index, 1);
              _this7.closeUpdatingForm(associationId);
              _this7.getOrderReconciliations();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    closeUpdatingForm: function closeUpdatingForm(associationId) {
      this.updatingForms = this.updatingForms.filter(function (x) {
        return x.associationId !== associationId;
      });
    },
    confirmDeleteAssociation: function confirmDeleteAssociation(associationId, ecItemId) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.$refs.confirm.open("Delete", "Are you sure you want to delete this association ?", {
                color: "red"
              });
            case 2:
              ok = _context6.sent;
              if (ok) _this8.deleteAssociation(associationId, ecItemId);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    deleteAssociation: function deleteAssociation(associationId, ecItemId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this9.isDeleting.push({
                associationId: associationId,
                ecItemId: ecItemId
              });
              _this = _this9;
              _context7.next = 4;
              return request("/v1/accountancy/oc-ec-item-associations/".concat(associationId), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update association", true);
                handleErrorData(_this, errorData);
                _this.isDeleting = _this.isDeleting.filter(function (x) {
                  return x.associationId !== associationId;
                });
                throw e;
              });
            case 4:
              _this9.isDeleting = _this.isDeleting.filter(function (x) {
                return x.associationId !== associationId;
              });
              _this9.getOrderReconciliations();
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    open: function open() {
      this.dialog = true;
    },
    close: function close() {
      this.dialog = false;
      this.$emit("closed");
    },
    orderDetails: function orderDetails(orderId) {
      var routeParams = {};
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId,
          routeParams: routeParams
        }
      };
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    wineNaming: wineNaming,
    filterIntegerKey: filterIntegerKey,
    filterDecimalKey: filterDecimalKey
  }
};